export const isCustomDomain = (): boolean => {
  if (typeof window !== 'undefined') {
    const isCustomDomain = window.location.hostname !== (process.env.NEXT_PUBLIC_SIO_HOSTNAME || '')
    return isCustomDomain
  }
  return false
}
